import { createAction } from '@ngrx/store';

export const globalSpinnerActions = {
  dispose: createAction('[Global Spinner] Dispose'),
  request: createAction('[Global Spinner] Request'),
};
